import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddEditFlagModalComponent } from './components';
import { FeatureFlagUI } from 'src/app/domains/feature-flags/models/feature-flags.model';
import { Subject } from 'rxjs';
import { catchError, switchMap, take, takeUntil } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { FeatureFlagsService } from 'src/app/domains/feature-flags/services';
import { FeatureFlag } from 'voxloud-types/dist/models';

@Component({
  selector: 'gdp-feature-flags',
  templateUrl: './feature-flags.component.html',
  styleUrls: ['./feature-flags.component.scss']
})
export class FeatureFlagsComponent implements OnInit, OnDestroy {
  private readonly modalService: NgbModal = inject(NgbModal);
  private readonly notification: NotificationService = inject(NotificationService);
  private readonly featureFlagService: FeatureFlagsService = inject(FeatureFlagsService);
  private readonly fetchTrigger$ = new Subject<void>();
  private readonly destroy$ = new Subject<void>();
  public fetchFailed: boolean = false;
  public loading: boolean = false;
  public flags: FeatureFlag[] = [];

  ngOnInit(): void {
    this.fetchTrigger$.pipe(
      switchMap(() => {
        this.loading = true;
        this.fetchFailed = false;
        return this.featureFlagService.getAllFeatureFlags().pipe(
          catchError(() => {
            this.fetchFailed = true;
            this.loading = false;
            return EMPTY;
          })
        );
      }),
      takeUntil(this.destroy$)
    ).subscribe({
      next: (res: FeatureFlag[]) => {
        this.flags = res;
        this.loading = false;
      }
    });
    this.fetchFlags();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onAddFlag() {
    const flag: FeatureFlagUI = {
      id: 0,
      key: '',
      description: '',
      is_enabled: true,
      isEditing: false,
      enabled_company_ids: [],
      rollout_percentage: 0
    }
    const modal = this.modalService.open(AddEditFlagModalComponent, { size: 'lg' });
    Object.assign(modal.componentInstance, {
      title: 'internal-facilities.feature-flags.add-edit-modal.add.title',
      flag: flag,
      flags: this.flags
    });
    modal.componentInstance.onFlagSubmit.pipe(take(1)).subscribe({
      next: () => {
        this.fetchFlags();
        this.notification.success('internal-facilities.feature-flags.success.add');
      }
    });
  }


  public fetchFlags(): void {
    this.fetchTrigger$.next();
  }

  public flagEdited(): void {
    this.notification.success('internal-facilities.feature-flags.success.edit');
    this.fetchFlags();
  }

  public onFlagDelete(): void {
    this.notification.success('internal-facilities.feature-flags.success.delete');
  }

}
